<template>
  <ez-table v-bind="$attrs" :headers="mergedHeaders" v-on="$listeners">
    <template v-for="(_, name) in $scopedSlots" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </ez-table>
</template>

<script>
import EzTable from '@/components/ui/Table';
import EzSortableHeader from '@/components/ui/Table/EzSortableHeader.vue';

export default {
  name: 'EzSortableTable',
  components: { EzTable },
  inheritAttrs: false,
  props: {
    sortableColumns: {
      type: Object,
      default: () => ({}),
    },
    headers: {
      type: Object,
      default: () => ({}),
    },
    sortBy: {
      type: String,
      default: null,
    },
    sortOrder: {
      type: String,
      default: 'DESC',
    },
  },
  computed: {
    mergedHeaders() {
      const activeKey = this.sortBy;
      const direction = this.sortOrder;
      const { onSort } = this;
      const result = { ...this.headers };
      Object.keys(this.sortableColumns).forEach(key => {
        const { sortKey = key, label = key, mode = 'both', dataCy } = this.sortableColumns[key] || {};
        result[key] = h =>
          h(EzSortableHeader, {
            props: { label, sortKey, activeKey, direction, mode, dataCy },
            on: { sort: onSort },
          });
      });
      return result;
    },
  },
  methods: {
    onSort({ sortBy, direction }) {
      this.$emit('sortChange', { sortBy, sortOrder: direction });
    },
  },
};
</script>
